import React from 'react';
import style from '../index.scss';

const BasicInfo = ({ typology = {} }) => {
  const {
    title,
    description,
    financialInstrument = [],
    technique = [],
    location = [],
    segment = []
  } = typology;
  return (
    <div className={style.mainDiv}>
      <p>Typology Basic Info</p>
      <h4>{title}</h4>
      <div className={style.descBox}>
        <p>Description</p>
        <span>{description}</span>
      </div>
      <div className={style.info}>
        <div className={style.infoRow}>
          <span className={style.label}>Segment</span>
          <span className={style.value}>{segment.toString()}</span>
        </div>
        <div className={style.infoRow}>
          <span className={style.label}>Technique</span>
          <span className={style.value}>{technique.toString()}</span>
        </div>
        <div className={style.infoRow}>
          <span className={style.label}>Location</span>
          <span className={style.value}>{location.toString()}</span>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
